var _defs, _path, _g, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBiconomy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 858.73 174.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.16,139.37H0V0H28.67c20.74,0,29.42,1.51,37.72,6.79,10,6.41,15.84,17.35,15.84,30.36s-4.34,20.37-15.46,26.21c17.73,7.35,23.76,17.92,23.76,34.51,0,25.47-17.54,41.5-53.37,41.5Zm-.76-114.09h-10.56v28.48h8.3c15.65,0,22.25-4.34,22.25-14.33,0-9.63-6.6-14.15-19.99-14.15Zm1.7,53.74h-12.26v35.64h12.82c18.1,0,25.84-5.28,25.84-17.35s-8.48-18.29-26.4-18.29Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 100.45,
    y: 34.89,
    width: 25.08,
    height: 104.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 100.64,
    width: 25.08,
    height: 25.08
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M192.3,141.82c-30.93,0-55.82-24.33-55.82-54.69s24.14-54.69,55.07-54.69c23.76,0,44.51,13.39,52.62,37.34h-28.29c-5.09-9.62-13.01-14.33-24.33-14.33-17.35,0-29.8,13.2-29.8,31.49s13.01,31.87,30.36,31.87c10.37,0,17.54-4.15,23.76-13.77h28.29c-8.68,23.39-27.54,36.78-51.86,36.78Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M306.74,141.82c-30.55,0-55.45-24.52-55.45-54.69s24.89-54.69,55.26-54.69,55.82,24.33,55.82,55.45c0,29.42-25.26,53.93-55.63,53.93Zm0-86.37c-16.41,0-30.17,14.14-30.17,31.31s13.39,32.06,30.36,32.06,30.17-14.14,30.17-31.68c.01-17.36-13.57-31.69-30.36-31.69Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M440.01,139.37v-51.11c0-27.91-7.54-32.81-19.99-32.81-7.92,0-14.52,3.39-18.48,9.62-3.21,5.09-4.15,11.13-4.15,25.08v49.22h-25.08V34.89h23.2v9.99c9.24-8.86,17.54-12.45,29.42-12.45,14.52,0,25.84,5.28,32.63,15.09,5.66,8.11,7.54,17.16,7.54,35.83v56.01h-25.09Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M530.46,141.82c-30.55,0-55.45-24.52-55.45-54.69s24.89-54.69,55.26-54.69,55.82,24.33,55.82,55.45c0,29.42-25.27,53.93-55.63,53.93Zm0-86.37c-16.41,0-30.17,14.14-30.17,31.31s13.39,32.06,30.36,32.06,30.17-14.14,30.17-31.68-13.58-31.69-30.36-31.69Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M727.66,139.37v-57.33c0-20.93-7.92-26.59-19.61-26.59-13.96,0-21.12,7.54-21.12,32.44v51.48h-25.08v-57.33c0-20.56-7.17-26.59-20.37-26.59-14.52,0-20.37,7.73-20.37,32.44v51.48h-25.08V34.89h23.01v9.81c7.36-8.86,14.9-12.26,27.16-12.26,14.33,0,23.57,4.9,30.74,16.22,8.49-11.32,18.86-16.22,33.57-16.22,27.53,0,42.24,15.28,42.24,46.58v60.35h-25.09Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M798.38,174.26h-26.97l19.61-44.7-38.28-94.67h28.67l23.2,67.7,25.27-67.7h28.85l-60.35,139.37Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiconomy);
export default __webpack_public_path__ + "static/media/biconomy.67f64bfb4467edaed7c4b380a93fd8aa.svg";
export { ForwardRef as ReactComponent };